<script lang="ts" setup>
import { DropdownProps } from "~/components/Filters/Utils/Dropdown.props"

const props = withDefaults(defineProps<DropdownProps>(), {
  contentClass: "",
  attachTo: "left",
  nFilters: 0,
  nResults: 0,
  opened: false,
  hideControls: false
})

const emit =
  defineEmits<{
    (e: "onOpen"): void
    (e: "onClose"): void
    (e: "onToggle"): void
    (e: "onDelete"): void
    (e: "onApply"): void
  }>()

const dropdownRef = ref<HTMLDivElement | null>(null)
const onLeftSide = computed(() => props.attachTo === "left")

const { nbHits, getFiltersNumbersByState } = useSwiftSearchHelper()

const closeDropdown = (resetOptions: boolean = true) => {
  if (!props.opened) emit("onOpen")
  if (resetOptions) emit("onClose")
  emit("onToggle")
}

const handleApply = () => {
  closeDropdown(false)
  emit("onApply")
}

onClickOutside(dropdownRef, () => {
  if (!props.opened) return
  closeDropdown()
})

const getFiltersNumbers = () => getFiltersNumbersByState(props.facetName)
</script>

<template>
  <div ref="dropdownRef" class="dropdown relative inline-block">
    <FiltersUtilsDropdownButton
      :text="text"
      :n-filters="getFiltersNumbers()"
      :opened="opened"
      @onClick="closeDropdown"
    />
    <Transition name="slide-fade" appear>
      <div
        v-show="opened"
        class="
          dropdown__content
          absolute
          top-[41px]
          z-10
          rounded-b-lg
          bg-white
          shadow-02
        "
        :class="[
          contentClass,
          { 'left-0': onLeftSide, 'right-0': !onLeftSide }
        ]"
      >
        <slot />
        <div
          v-if="!hideControls"
          class="
            dropdown__controls
            mt-4
            flex
            gap-x-4
            border-t border-black-10
            pt-4
          "
        >
          <AisClearRefinements :included-attributes="facetName" :id="idFacet">
            <template v-slot="{ refine }">
              <UtilsButton
                theme="outlined-green"
                :text="$t('filters.utils.common.reset')"
                @click="refine()"
              />
            </template>
          </AisClearRefinements>

          <UtilsButton
            class="whitespace-nowrap"
            :text="`${$t('filters.utils.dropdown.apply')} (${nbHits})`"
            fluid
            @click="handleApply"
          />
        </div>
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

</style>
